const ALL = '.input-group .form-control';

const focus = (event) => event.target.closest('.input-group').classList.add('focus')
const blur = (event) => event.target.closest('.input-group').classList.remove('focus')

const applyInputGroupClass = (formControl) => {
  const inputGroup = formControl.closest('.input-group')
  const add = []
  const remove = []

  formControl.disabled ? add.push('disabled') : remove.push('disabled')
  formControl.readOnly ? add.push('readonly') : remove.push('readonly')
  formControl.classList.contains('is-invalid') ? add.push('is-invalid') : remove.push('is-invalid')

  inputGroup.classList.remove(...remove)
  inputGroup.classList.add(...add)
}

const inputGroupObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => applyInputGroupClass(mutation.target))
})

const applyInputIconClass = (input) => {
  const inputGroup = input.closest('.input-group');
  const icon = inputGroup.querySelector('.icon svg');

  if (icon) {
    icon.classList.toggle("active", input.value.length)
  }
}

const inputGroup = (element) => {
  if('inputGroup' in element.dataset) return

  element.dataset.inputGroup = true
  element.addEventListener('focus', focus)
  element.addEventListener('blur', blur)
  element.addEventListener('input', () => applyInputIconClass(element))
  applyInputGroupClass(element)
  applyInputIconClass(element)

  inputGroupObserver.observe(element, {
    attributes: true,
    attributeFilter: ['class', 'readonly', 'disabled']
  })
}

const attachAll = () => {
  document.querySelectorAll(ALL).forEach((element) => inputGroup(element))

  const observer = new MutationObserver((mutations) => {
    mutations.filter((m) => m.addedNodes.length > 0).forEach((mutation) => {
      mutation.target.querySelectorAll(ALL).forEach((element) => inputGroup(element))
    })
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })
}

export default { attachAll }
